import { Fetch } from 'lib';
import type { PageBannersSettings } from 'types';

type RequestResponses = {
  pageSettings: PageBannersSettings;
};

const getPageBanners = async () =>
  await Fetch<RequestResponses>({
    url: 'adminPageBuilder/getPageBanners',
  });

export { getPageBanners };
